import { Grid, Typography } from "@mui/material";
import { FunctionComponent } from "react";
import { DuplicateIcon, EditIcon, HideIcon, TrashIcon, UnhideIcon } from "../../icon";
import { PlanModel, TierOccurrence } from "../../models/plans.model";
import ButtonComponent from "../shared/button/button.component";
import { buttonLabels } from "../shared/constants";
import CounterComponent from "../shared/counter.component";
import GridOptions from "../shared/grid-options.component";
import { useSelector } from "react-redux";
import * as selector from "../../selectors/selectors";

interface Props extends PlanModel {
    openDisableAddOnDialog?: (id: string) => void;
    openConfirmAddOnDialog?: (id: string) => void;
    openEditPlan?: (id: string, isAddon?: boolean) => void;
    Duplicate?: (id: string, isAddon?: boolean) => void;
    ShowAddOnOptions: boolean;
    OnSelectionChange?: (count: number) => void;
    HideBuyNow?: boolean;
    Index: any;
    EnableAddonSelection?: boolean;
    SelectionCount?: number;
    MinSelection?: number;
    MaxSelection?: number;
}

const AddOnComponent: FunctionComponent<Props> = (props) => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const IsDarkMode: boolean = useSelector(selector.isDarkMode)

    return (
        <Grid md={4} sm={6} xs={12} item>
            <div className={`${props.IsDeleted ? 'add-on-main-card-inactive box-shadow-display-background-shadow' : `add-on-main-card ${props.Index ? "bg-color-primary-light " : `${IsDarkMode ? "bg-color-sidebar-bg" : "bg-color-secondary"}`} box-shadow-display-background-shadow`} p-relative my-2 mx-3 o-x-hidden`}>

                <div className={"d-flex"}>
                    {/* <div className={` ${props.IsDeleted ? 'color-add-on-text' : props.Index ?  `${IsDarkMode ? "" : "bg-color-secondary"}` : "color-add-on-text"} ${IsMobileDevice ? 'h1' : 'h2-semibold'} `} >{`$${props.Price}`}</div> */}
                    <div className={`add-on-drop-card d-flex w-p-3 t-0 r-5 p-1 p-absolute ${props.IsDeleted ? 'bg-color-add-on-ribbon-inactive' : props.Index ? `${IsDarkMode ? "bg-color-sidebar-bg" : "bg-color-secondary"}` : "bg-color-primary-light"}`}> <div className={`w-space ${!IsMobileDevice ? 'h5-regular my-0 h-8' : 'h5 mr-2 h-6'} ${props.IsDeleted ? 'color-add-on-ribbon-title-inactive' : props.Index ? `${IsDarkMode ? "" : "color-primary-light"}` : ` ${IsDarkMode ? "" : "color-secondary"}`} add-on-text-rotation`}>{props.TierOccurrence === TierOccurrence.ONE_TIME ? 'One Time' : 'Recurring'}</div> </div>                    {props.ShowAddOnOptions && <div className='p-absolute r-0 t-1'>
                        <GridOptions
                            data={[{
                                btnName: "Edit",
                                btnColor: "primary",
                                onClickbtn: () => { if (props.openEditPlan) { props.openEditPlan(props.PlanID, true) } },
                                btnIcon: EditIcon
                            },
                            {
                                btnName: props.IsDeleted ? "Unhide" : "Hide",
                                btnColor: props.IsDeleted ? "secondary" : "primary",
                                onClickbtn: () => { if (props.openDisableAddOnDialog) { props.openDisableAddOnDialog(props.PlanID) } },
                                btnIcon: props.IsDeleted ? UnhideIcon : HideIcon
                            },
                            {
                                btnName: "Duplicate",
                                btnColor: "primary",
                                onClickbtn: () => props.Duplicate && props.Duplicate(props.PlanID, true),
                                btnIcon: DuplicateIcon
                            },
                            {
                                btnName: "Delete", btnColor: "primary",
                                onClickbtn: () => { if (props.openConfirmAddOnDialog) { props.openConfirmAddOnDialog(props.PlanID) } },
                                btnIcon: TrashIcon
                            }]}
                            IsTiers={(props.Index % 2 === 1)}
                            DisabledIcon={props.IsDeleted}
                        />
                    </div>}

                </div>
                {props.Features.map(item =>
                    <>
                        <p className={`${props.IsDeleted ? 'color-add-on-text' : props.Index ? `${IsDarkMode ? "" : "color-secondary"}` : "color-add-on-text"} ${IsMobileDevice ? 'h1' : 'h2-semibold w-break'}`}>{props.Name}</p>
                        <Typography className={`${IsMobileDevice ? 'h4' : 'h5-regular'} ${props.IsDeleted ? 'color-add-on-text' : props.Index ? `${IsDarkMode ? "" : "color-secondary"}` : "color-add-on-text"} mb-2`} key={item.ID}>{item.Label}</Typography>
                        <Typography className={`h5-regular ${IsMobileDevice ? 'h4' : 'h5-regular'} ${props.IsDeleted ? 'color-add-on-text' : props.Index ? `${IsDarkMode ? "" : "color-secondary"}` : "color-add-on-text"}`}>{props.TierOccurrence === TierOccurrence.ONE_TIME ? 'Validity:' : ''} {item.Validity === -1 && props.TierOccurrence === TierOccurrence.ONE_TIME ? "Unlimited" : null}</Typography>
                        {props.Footnote &&
                            <div className='t-align-left mt-1'>
                                <Typography className={`${IsMobileDevice ? 'h4' : 'h5-regular'} w-break mb-1 ${props.IsDeleted ? 'color-primary-accent' : (props.Index % 2 === 1) ? 'color-secondary' : ''} `} gutterBottom>{props.Footnote}</Typography>
                            </div>
                        }
                    </>
                )}
                <div className='d-flex'>
                    {
                        !props.HideBuyNow && !props.EnableAddonSelection ?
                            <ButtonComponent OnClick={() => props.OnSelectionChange && props.OnSelectionChange(1)} ButtonLabel={buttonLabels.BUY_NOW} ClassName={`mx-auto mt-2 br-6 button-add-on w-p-100 t-align-center justify-center ${IsMobileDevice ? 'h2' : 'h4-regular'} ${props.Index ? "add-on-secondary-btn-hover" : "add-on-primary-btn-hover"}`} Variant={props.IsDeleted ? "disabled-btn" : props.Index ? "primary-btn" : "secondary-btn"} />
                            : props.EnableAddonSelection && !props.SelectionCount ?
                                <ButtonComponent OnClick={() => props.OnSelectionChange && props.OnSelectionChange(1)} ButtonLabel={buttonLabels.ADD_PLUS} ClassName={`mx-auto mt-2 br-6 button-add-on w-p-100 t-align-center justify-center ${IsMobileDevice ? 'h2' : 'h4-regular'} ${props.Index ? `${IsDarkMode ? "bg-color-sidebar-bg" : "add-on-secondary-btn-hover"} ` : "add-on-primary-btn-hover"}`} Variant={props.IsDeleted || props.HideBuyNow ? "disabled-btn" : props.Index ? "secondary-btn" : "primary-btn"} />
                                :
                                props.SelectionCount &&
                                <div className="mt-3 mx-auto">
                                    <CounterComponent
                                        inverted={!!props.Index}
                                        count={props.SelectionCount || 0}
                                        min={props.MinSelection === undefined ? 0 : props.MinSelection}
                                        max={props.MaxSelection === undefined ? 10 : props.MaxSelection}
                                        onChange={(count) => props.OnSelectionChange && props.OnSelectionChange(count)}
                                        IsMobileDevice={IsMobileDevice}
                                        Features={props.Features}
                                    />
                                </div>
                    }
                </div>
            </div>
        </Grid>
    );
}

export default AddOnComponent;